import './static/extra.css'

export const onRouteUpdate = ({ location, prevLocation }) => {
  requestIdleCallback(() => MathJax.typeset())
}
